import React from 'react';
import axios from 'axios';
import {
  Segment,
  Header,
  Table,
  Message,
  Tab,
  Divider,
}  from 'semantic-ui-react';
import { contractPopulate } from './helpers/contractPopulate';
import { PaneDealer } from './PaneDealer';
import { PaneDocuments } from './PaneDocuments';
import { PaneImages } from './PaneImages';
import { PanePdf } from './PanePdf';
import { PaneRenter } from './PaneRenter';
import { PaneSystem } from './PaneSystem';
import { PaneTerms } from './PaneTerms';

const baseUrl = 'dealer';

class ContractOverview extends React.Component {
  state = {
    loading: true,
    reqResponse: null,
    billOfSale: null,
    signedAch: null,
    registrationCerts: [],
  }

  componentDidMount = () => {
    const { contractId } = this.props;

    axios.get(`/contracts/${contractId}`)
      .then(res => {
        const { data } = res;
        const contractData = contractPopulate(data);

        const systems = data.hvac_systems.map(sys => ({
          documents: sys.registration_certificate_images,
          name: sys.name,
        }));

        this.setState({
          ...contractData,
          billOfSale: data.bill_of_sale ? data.bill_of_sale : null,
          signedAch: data.signed_ach_authorization_image ? data.signed_ach_authorization_image : null,
          pdfFilename: data.contract_pdf_filename,
          loading: false,
          registrationCerts: systems,
        });
      })
      .catch(err => {
        this.setState({
          reqResponse: {
            header: 'Oops!',
            success: false,
            content: 'There was a problem loading the contract',
          },
          loading: false,
        });
      })
  }

  render() {
    const {
      id,
      status,
      loading,
      reqResponse,
    } = this.state;

    if (loading) {
      return null;
    }

    if (reqResponse) {
      return (
        <Message
          icon="exclamation"
          header={reqResponse.header}
          positive={reqResponse.success ? true : false}
          error={!reqResponse.success ? true : false}
          content={reqResponse.content}
        />
      );
    }

    let reviewPanes = [
      {
        menuItem: {
          key: 'dealer',
          content: 'Dealer',
          icon: 'building',
        },
        render: () => (
          <PaneDealer
            dealer={this.state.dealer}
            salesperson={this.state.salesperson}
          />
        )
      },
      {
        menuItem: {
          key: 'systems',
          content: 'System',
          icon: 'cogs',
        },
        render: () => (
          <PaneSystem
            systems={this.state.systems}
          />
        )
      },
      {
        menuItem: {
          key: 'users',
          content: 'Renter',
          icon: 'users',
        },
        render: () => (
          <PaneRenter
            coRenter={this.state.coRenter}
            renter={this.state.renter}
          />
        )
      },
      {
        menuItem: {
          key: 'terms',
          content: 'Terms',
          icon: 'dollar',
        },
        render: () => (
          <PaneTerms
            additionalCost={this.state.additional_cost}
            taxState={this.state.tax_state}
            term={this.state.term}
          />
        ),
      },
      // {
      //   menuItem: {
      //     key: 'images',
      //     content: 'Images',
      //     icon: 'images',
      //   },
      //   render: () => (
      //     <PaneImages
      //       baseUrl={baseUrl}
      //       contractImages={this.state.contractImages}
      //       coRenter={this.state.coRenter}
      //       renter={this.state.renter}
      //     />
      //   )
      // },
      {
        menuItem: {
          key: 'pdf',
          content: 'PDF',
          icon: 'file pdf',
        },
        render: () => (
          <PanePdf
            baseUrl={baseUrl}
            pdfFilename={this.state.pdfFilename}
          />
        )
      },
      {
        menuItem: {
          key: 'docs',
          content: 'Documents',
          icon: 'file',
        },
        render: () => (
          <PaneDocuments
            baseUrl={baseUrl}
            billOfSale={this.state.billOfSale}
            registrationCerts={this.state.registrationCerts}
            signedAch={this.state.signedAch}
          />
        )
      }
    ];

    if (status == 1 || status == 3) {
      reviewPanes = reviewPanes.filter(p => p.menuItem.key !== 'docs');
    }

    return (
      <Segment className="no-style-segment" loading={loading}>
        <Header
          as="h3"
          content="Contract Details"
          subheader="NON-EDITABLE, VIEW-ONLY"
        />
        <div>
          <Divider hidden />
          <Tab panes={reviewPanes} />
        </div>
      </Segment>
    );
  }
}

export default ContractOverview;
